import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";

export default function BlogTeaser() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data.slice(0, 3))).catch(() => {});
  }, []);

  return (
    <section data-testid="blog-teaser" className="section bg-bone">
      <div className="container-max">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between mb-14 gap-6">
          <div>
            <p className="overline">— Journal</p>
            <h2 className="font-display font-light text-5xl md:text-7xl leading-[0.95] tracking-tighter mt-6">
              Notes <em className="italic text-terracotta">d'atelier</em>.
            </h2>
          </div>
          <Link to="/journal" className="btn-ghost">
            Tous les articles
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {posts.map((p, i) => (
            <motion.article
              key={p.slug}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="group"
              data-testid={`blog-card-${p.slug}`}
            >
              <Link to={`/journal/${p.slug}`}>
                <div className="aspect-[5/4] overflow-hidden bg-ivory">
                  <img src={p.cover} alt={p.title} className="w-full h-full object-cover img-zoom" loading="lazy" />
                </div>
                <div className="mt-5 flex items-center gap-3 overline text-ink/50">
                  <span>{p.category}</span>
                  <span className="w-1 h-1 bg-ink/30" />
                  <span>{p.read_time}</span>
                </div>
                <h3 className="font-display text-2xl md:text-3xl mt-3 leading-tight">{p.title}</h3>
                <p className="mt-3 text-ink/70 leading-relaxed">{p.excerpt}</p>
                <span className="inline-flex items-center gap-2 mt-4 overline link-arc">
                  Lire <ArrowUpRight className="w-3 h-3" />
                </span>
              </Link>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
